import styled from "styled-components";

export default styled.img.attrs({
  src: require("assets/image/yellow-tick.webp"),
  alt: "Golden Tick"
})`
  margin-left: 2px;
  position: relative;
  bottom: -2px;
`;
